module.exports = __webpack_public_path__ + "static/shelly-doyle-5e0eda9e874dbf79007129aae846232c.jpg";